import { VegaFlex, VegaText, VegaIcon, VegaCard, VegaBox } from "@heartlandone/vega-react";
import dayjs from 'dayjs';
import './module.css';
import ActivityStateindicator from 'Components/ActivityStateindicator/ActivityStateindicator';
import defaultImage from "./assets/default-cover.png";

function RegisterActivityListItem(props) {
  const { activity, isShowActivityState = true } = props;
  const { city, address, activityStatus, isOnlineActivity, registerNumberLimitType, chargeAmount = 0, endTime, participantsCount = 0, registerNumberLimit = 0, startTime, title, coverUrl, publisherCategory, registerSetting } = activity;

  const _getCharge = (charge) => (charge <= 0 ? `Free` : `$ ${charge}`);

  return (
    <VegaCard padding={'size-24'} variant="border">
      <VegaFlex justifyContent={'space-between'} gap={'size-12'}>
        <VegaFlex direction={'col'} gap={'size-12'}>
          <VegaFlex gap={'size-8'}>
            { isShowActivityState ? <ActivityStateindicator activityStatus={activityStatus}/> : <></> }
            <VegaFlex
              alignItems={'center'}
              gap={'size-4'}
              className={`indicator activity-indicator-border`}
            >
              {publisherCategory}
            </VegaFlex>
            <VegaFlex
              alignItems={'center'}
              gap={'size-4'}
              className={`indicator activity-indicator-border`}
            >
              {_getCharge(chargeAmount)}
            </VegaFlex>
          </VegaFlex>
          <VegaFlex>
            <VegaText className="f-size-20 font-normal f-weight-700 line-height-28">{title}</VegaText>
          </VegaFlex>
          <VegaFlex className='font-light-text-color-secondary'>
            <VegaBox width="size-16" height="size-16">
                <VegaIcon
                  size="size-16"
                  icon="fal fa-clock"
                  color="text-secondary"
                ></VegaIcon>
              </VegaBox>
            <VegaText className="m-l-12 f-size-14 font-normal f-weight-400 line-height-16">{dayjs(startTime).format('MM/DD/YYYY, HH:mm')} - {dayjs(endTime).format('MM/DD/YYYY, HH:mm')}</VegaText>
          </VegaFlex>
          <VegaFlex className='font-light-text-color-secondary'>
            <VegaBox width="size-16" height="size-16" className="v-text-center">
              <VegaIcon
                icon={isOnlineActivity ? "fal fa-presentation-screen" : "fal fa-location-dot"}
                size="size-16"
                color="text-secondary"
              ></VegaIcon>
            </VegaBox>
            <VegaText className="m-l-12 f-size-14 font-normal f-weight-400 line-height-16">{isOnlineActivity ? "Online Activity" : `${city} - ${address}`}</VegaText>
          </VegaFlex>
          <VegaFlex className='font-light-text-color-secondary'>
            <VegaBox width="size-16" height="size-16">
              <VegaIcon
                icon="fa-light fa-users-viewfinder"
                size="size-16"
              ></VegaIcon>
            </VegaBox>
            <VegaText className="m-l-12 f-size-14 font-normal f-weight-400 line-height-16">Participants ({participantsCount}{registerNumberLimitType === 'Limited' ? `/${registerNumberLimit}` : ''})</VegaText>
          </VegaFlex>
          {
            registerSetting?.isAllowInviteGuests ? (
              <VegaFlex className="font-light-text-color-secondary">
                <VegaBox width="size-16" height="size-16">
                  <VegaIcon
                    icon="fa-light fa-user-plus"
                    size="size-16"
                  />
                </VegaBox>
                <VegaText className="m-l-12 f-size-14 font-normal f-weight-400 line-height-16">
                  Guest Allowed
                </VegaText>
              </VegaFlex>
            ) : <></>
          }
        </VegaFlex>
        <VegaFlex></VegaFlex>
        <VegaFlex>
          <div className='round-12' style={{
              backgroundImage: `url(${ coverUrl || activity?.cover?.url || defaultImage})`,
              width: 280,
              height: 130,
              backgroundSize: 'cover',
          }}></div>
        </VegaFlex>
      </VegaFlex>
    </VegaCard>
  );
}

export default RegisterActivityListItem;
